var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import Draggable from 'vuedraggable';
import { cloneDeep, debounce, isEqual } from "lodash-es";
import { INJECT_UICORE_BUS } from "../../../../lib/utils/consts";
import { createNewColumn } from './getDefaultColumns';
import ColEditor from './ColEditor';
import "./ColsEditor.css";
let ColsEditor = class ColsEditor extends Vue {
  constructor() {
    super(...arguments);
    this.tempValue = [];
  }
  addColumn() {
    this.tempValue.push(createNewColumn());
    this.commit();
  }
  deleteColumn(idx) {
    this.tempValue.splice(idx, 1);
    this.commit();
  }
  get draggableAttrs() {
    return {
      draggable: '.ucd-colEditor',
      handle: '.ucd-colEditor-handle',
      animation: 300
    };
  }
  handleDragEnd({
    oldIndex,
    newIndex
  }) {
    const spliced = this.tempValue.splice(oldIndex, 1);
    this.tempValue.splice(newIndex, 0, ...spliced);
    this.commit();
  }
  commit() {
    this.commitDebounced.cancel();
    this.$emit('change', cloneDeep(this.tempValue));
  }
  created() {
    this.commitDebounced = debounce(() => {
      this.commit();
    }, 200);
    this.$watch(() => this.value || [], newValueFromOutside => {
      if (!isEqual(newValueFromOutside, this.tempValue)) {
        this.tempValue = cloneDeep(newValueFromOutside);
      }
    }, {
      immediate: true,
      deep: true
    });
  }
  beforeDestroy() {
    this.commitDebounced.flush();
  }
  render() {
    const h = arguments[0];
    return h("div", {
      "class": "ucd-colsEditor"
    }, [h(Draggable, {
      "class": "ucd-colsEditor-cols",
      "attrs": {
        "value": this.tempValue,
        ...this.draggableAttrs
      },
      "on": {
        "end": this.handleDragEnd
      }
    }, [this.tempValue.map((col, i) => h(ColEditor, {
      "key": col.id,
      "attrs": {
        "index": i,
        "value": col
      },
      "on": {
        "delete": this.deleteColumn,
        "change": this.commitDebounced
      }
    }))]), h("div", {
      "class": "ucd-colsEditor-footer"
    }, [h("button", {
      "class": "uc-button",
      "on": {
        "click": this.addColumn
      }
    }, [h("i", {
      "class": "fa fa-plus"
    }), ' 添加列'])])]);
  }
};
ColsEditor = __decorate([Component({
  name: 'ColsEditor',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    }
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
})], ColsEditor);
export default ColsEditor;
//# sourceMappingURL=ColsEditor.js.map
